// @ts-nocheck
/* eslint-disable camelcase */
import * as React from 'react';
import CompleteFooter from 'components/CompleteFooter';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';
import { universityActions } from 'ducks/university/actions';
import Loader from 'components/uielements/Loader';
import { UniversityBio } from './UniversityBio';
import { LinkContainer, StyledLink, FilterContainer } from './University.styles';
import { SchoolInfo } from './SchoolInfo';
import { Filter } from './Filter';
import { Programs } from './Programs';

const getDataFromActiveSchool = (university, activeSchool) =>
  university?.schools?.filter(({ name }) => name === activeSchool)[0];

const University = (): React.ReactElement<any> => {
  const [activeSchool, setActiveSchool] = React.useState('');
  const dispatch = useDispatch();
  const { slug } = useParams();
  const { isLoading, data: university } = useSelector((state) => state.university.university);

  const handleFilter = (event: React.SyntheticEvent<HTMLButtonElement>): void => {
    const schoolName = event.currentTarget.name;

    if (schoolName !== activeSchool) {
      setActiveSchool(schoolName);
    }
  };

  React.useEffect(() => {
    if (!slug) return;
    dispatch(universityActions.getUniversityRequest(slug));
  }, [slug]);
  React.useEffect(() => {
    if (!university) return;
    setActiveSchool(university.schools[0].name);
  }, [university]);

  const renderFilters = (): React.ReactElement<any> | null => {
    if (!university?.schools?.length) return null;
    return university?.schools?.map(({ name }) => (
      <Filter active={name === activeSchool} key={name} onClick={handleFilter} name={name} />
    ));
  };

  if (isLoading) {
    return <Loader />;
  }

  return (
    <>
      <div>
        <LinkContainer>
          <StyledLink to='/courses/browse'>Programs</StyledLink>
        </LinkContainer>
        <UniversityBio
          name={university?.name}
          logo={university?.logo?.url}
          text={university?.short_description}
          campusImage={university?.dark_background_logo?.url}
        />
        <FilterContainer>{renderFilters()}</FilterContainer>
        <SchoolInfo
          logo={getDataFromActiveSchool(university, activeSchool)?.logo?.url}
          text={getDataFromActiveSchool(university, activeSchool)?.short_description}
        />
        <Programs
          logo={university?.logo?.url}
          text={university?.name}
          programs={getDataFromActiveSchool(university, activeSchool)?.partner_programs?.data}
        />
      </div>
      <CompleteFooter />
    </>
  );
};

export default University;
